export default function TrustSection() {
  return (
    <section className="relative py-20 md:py-28 px-6 md:px-10 bg-secondary-50">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold tracking-wide uppercase mb-6">
              Warum OOPBuy Spreadsheet?
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 leading-tight mb-6">
              Schneller finden, besser vergleichen, sicherer einkaufen
            </h2>
            <p className="text-foreground-600 text-base leading-relaxed max-w-lg">
              Die Suche nach passenden Produkten kann zeitaufwendig sein. Ein strukturiertes
              <strong className="text-foreground-900"> OOPBuy Spreadsheet </strong>
              hilft dabei, Produkte schneller zu finden, Kategorien zu vergleichen und bessere
              Entscheidungen zu treffen. Unsere Plattform bietet deutschen Nutzern eine
              übersichtliche und stets aktuelle Orientierung im OOPBuy-Universum.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-6">
            <div className="text-center p-6">
              <span className="font-heading text-5xl font-bold text-primary-500">14</span>
              <span className="font-heading text-3xl font-bold text-primary-500">+</span>
              <p className="text-foreground-500 text-sm mt-2">Produktkategorien</p>
            </div>
            <div className="text-center p-6">
              <span className="font-heading text-5xl font-bold text-accent-500">100</span>
              <span className="font-heading text-3xl font-bold text-accent-500">%</span>
              <p className="text-foreground-500 text-sm mt-2">Kostenlos nutzbar</p>
            </div>
            <div className="text-center p-6">
              <span className="font-heading text-5xl font-bold text-primary-500">DE</span>
              <p className="text-foreground-500 text-sm mt-2">Optimiert für Deutschland</p>
            </div>
            <div className="text-center p-6">
              <span className="font-heading text-5xl font-bold text-accent-500">24</span>
              <span className="font-heading text-3xl font-bold text-accent-500">/7</span>
              <p className="text-foreground-500 text-sm mt-2">Immer verfügbar</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}